<template>
    <div>
        <div class="hs-error">好大的404</div>
    </div>
</template>

<script>
    export default {
        name: "error404"
    }
</script>

<style scoped lang="less">
    .hs-error {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        font-size: 35px;
        align-items: center;
        justify-content: center;
    }
</style>